<template>
  <div class="member-list">
    <!--头部-->
    <!--<van-nav-bar title="用户统计" left-arrow @click-left="onClickLeft" border />-->
    <div class="list-con">
      <p class="list-title">一级用户：<span>{{ memberGrade.childrenCntLevel1 }}</span>人</p>
      <div class="bg-10px"></div>
      <p class="list-title">二级用户：<span>{{ memberGrade.childrenCntLevel2 }}</span>人</p>
    </div>
  </div>
</template>

<script>
import { memberPlatformGradeV2 } from '@/api/member'
export default {
  components: {
  },
  data () {
    return {
      memberGrade: {},

      // levels: [],// 会员等级
      //
      // // 一级用户统计
      // statL1: {
      //   memberCount: 0, // 用户数
      //   lv1Count: 0, // 蚂蚁会员人数
      //   lv2Count: 0, // 蚂蚁创客人数
      //   lv3Count: 0, // 蚂蚁导师人数
      //   lv1Percentage: 0, // 人数占比
      //   lv2Percentage: 0,
      //   lv3Percentage: 0,
      // },
      // // 二级用户统计
      // statL2: {
      //   memberCount: 0, // 用户数
      //   lv1Count: 0, // 蚂蚁会员人数
      //   lv2Count: 0, // 蚂蚁创客人数
      //   lv3Count: 0, // 蚂蚁导师人数
      //   lv1Percentage: 0, // 人数占比
      //   lv2Percentage: 0,
      //   lv3Percentage: 0,
      // },
    }
  },
  created(){
    this.memberPlatformGrade()
    // this.getMemberStatistics()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    memberPlatformGrade(){
      memberPlatformGradeV2({}).then(res=>{
        this.memberGrade = res.data || {}
      })
    },
    // getMemberStatistics() {
    //   countPlatformMember({}).then(res=>{
    //     let statL1 = res.data.statL1
    //     let statL2 = res.data.statL2
    //     if(statL1){
    //       this.statL1.memberCount = statL1.childrenCount
    //       statL1.levelStatList.forEach((item, i)=>{
    //         this.statL1[`lv${item.platformMemberLevel}Count`] = item.cnt || 0;
    //         this.statL1[`lv${item.platformMemberLevel}Percentage`] = item.percent || 0;
    //       })
    //     }
    //     if(statL2){
    //       this.statL2.memberCount = statL2.childrenCount
    //       statL2.levelStatList.forEach((item, i)=>{
    //         this.statL2[`lv${item.platformMemberLevel}Count`] = item.cnt || 0;
    //         this.statL2[`lv${item.platformMemberLevel}Percentage`] = item.percent || 0;
    //       })
    //     }
    //   })
    // }
  }
}
</script>

<style scoped lang="less">
@url: 'https://fileqn.anttalk.vip/';
.member-list{
  .list-con{
    position: fixed;
    overflow: auto;
    height: 100%;
    width: 100%;
    .list-title{
      line-height: 44px;
      padding: 0 12px;
      color: #2b2b2b;
      font-size: 16px;
      border-bottom: 1px solid #edecec;
    }
    .list{
      display: flex;
      /*padding: .2rem;*/
      box-shadow: 0 1px 0 0 rgba(9,9,9,0.03);
      height: 44px;
      .img-con{
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 46px;
        .icon-img{
          display: block;
          width: 19px;
          height: 28px;
        }
        .icon-img-1{
          background: url("@{url}FqvdyKzdOvhFc6yeHGCISPDh3Mq6") no-repeat 50% 50%;
          background-size: 19px 28px;
        }
        .icon-img-2{
          background: url("@{url}FmQsU_Ysx0rOaBp38p192_OKtyAY") no-repeat 50% 50%;
          background-size: 19px 28px;
        }
        .icon-img-3{
          background: url("@{url}Fn5_XQKTUnolmg_YGwNoqvaFFy6J") no-repeat 50% 50%;
          background-size: 19px 28px;
        }
      }
      .text-con{
        flex: 1;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        .text{
          color: #242424;
          font-size: 14px;
          .num{
            padding: 0 16px;
          }
          .blue{
            color: #2b86cc;
            padding-left: 6px;
          }
        }

      }
    }

  }
}
</style>
